import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableCopyPaste]'
})
export class DisableCopyPasteDirective {

  constructor() { }

  @HostListener('copy', ['$event'])
  onCopy(event: ClipboardEvent) {
    console.log('Copy event triggered');  // Add logs to confirm
    event.preventDefault();
  }

  @HostListener('cut', ['$event'])
  onCut(event: ClipboardEvent) {
    console.log('Cut event triggered');   // Add logs to confirm
    event.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    console.log('Paste event triggered');  // Add logs to confirm
    event.preventDefault();
  }

}
